  export const timeFilters = [
    { value: 'day', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'year', label: 'This Year' }
  ];

  export const metrics = [
    { value: 'usage', label: 'Usage Stats' },
    { value: 'revenue', label: 'Revenue' },
    { value: 'user-growth', label: 'User Growth' }
  ];

